import _ from 'lodash';

import { email as validateEmail } from '@coursera/coursera-ui/lib/utils/validation';

import EMAIL_DOMAINS from 'bundles/user-account/data/thirdPartyOrganizationEmailDomains';

const SSO_DOMAIN_LIST = EMAIL_DOMAINS.elements;
const SSO_DOMAIN_LIST_MAP = _.keyBy(SSO_DOMAIN_LIST, 'id');

export function getThirdPartyOrgByEmail(email: string): { thirdPartyOrganizationId: string } | undefined {
  if (email.length < 3) {
    return undefined;
  }
  const validationResult = validateEmail(email);
  if (!validationResult) {
    const domain = email.split('@')[1];
    return SSO_DOMAIN_LIST_MAP[domain];
  }
  return undefined;
}

/**
 * Get corresponding SSO versions with enterprise in consideration
 * V0: basic login/signUp form
 * V1: default show login/signUp form, with 'login with org' as secondary option
 * V2: default show email input and 'continue' button, if email is in SSO list, show SSO option
 * We can use isEnterprise and sso query params in the router to override the default rendering versions for quick test
 */
export function getEnabledVersions({
  authProvider,
  isEnterpriseProp,
  isEnterpriseRouter,
  sso,
}: {
  authProvider?: string;
  isEnterpriseProp?: boolean;
  isEnterpriseRouter?: 'false' | 'true';
  sso?: 'v1';
}): {
  isEnterprise: boolean;
  enableSSOLoginV0: boolean;
  enableSSOLoginV1: boolean;
} {
  let isEnterprise = isEnterpriseProp;

  // Always render V0 for enterprise users (at program home)
  // or if consumer url has authProvider (important for Group users)
  let enableSSOLoginV0 = isEnterprise || !!authProvider;
  let enableSSOLoginV1 = !enableSSOLoginV0 && !enableSSOLoginV0; // Render V1 if V0 is not on at the consumer side

  // Use router url rewrite for easy testing
  if (sso === 'v1') {
    enableSSOLoginV0 = false;
    enableSSOLoginV1 = true;
  }
  if (isEnterpriseRouter) {
    if (isEnterpriseRouter === 'true') {
      isEnterprise = true;
      enableSSOLoginV0 = true;
      enableSSOLoginV1 = false;
    } else {
      isEnterprise = false;
    }
  }

  return {
    isEnterprise: Boolean(isEnterprise),
    enableSSOLoginV0,
    enableSSOLoginV1,
  };
}
